module.exports = __webpack_public_path__ + "static/media/laura.bfab7c5d.jpg";